import { useEffect, useState } from "react";
import { useApi } from "../../context/ApiProvider";
import { useLocale } from "../../localization/LocaleProvider";
import moment from "moment";
import { Link } from "react-router-dom";

export default function Retention() {

  const { translate } = useLocale();
  const Api = useApi();

  const [unregistered, setUnregistered] = useState([]);
  const [isLoadingMembers, setIsLoadingMembers] = useState(false);
  const [checked, setChecked] = useState([]);

  useEffect(() => {
    fetchUnregistered();
  }, []);

  const fetchUnregistered = async () => {
    setIsLoadingMembers(true);
    Api.get(`/rolf/unregistered`).then(data => {
      setUnregistered(data);
    }).catch(e => {
    }).finally(() => {
      setIsLoadingMembers(false);
    })
  }


  return (
    <div className="grid-container">
      <section>
        <h4>{translate("Data retention")}</h4>


        <table>
          <thead>
            <tr>
              <th>{translate("Name")}</th>
              <th>{translate("Client")}</th>
              <th>{translate("Organisationer")}</th>
              <th>{translate("Unregister date")}</th>
              <th>
                <input type="checkbox" onClick={(v) => { v.target.checked ? setChecked(unregistered.map(member => member.ID)) : setChecked([]) }} />
              </th>
            </tr>
          </thead>
          <tbody>
            {unregistered && unregistered.length > 0 && unregistered.map((member, index) => {
              return (
                <tr key={index}>
                  <td>{member.ID}</td>
                  <td>
                    <span className="meta">{member.client}</span>
                  </td>
                  <td>
                    {member.organisations && member.organisations.length > 0 && member.organisations.map((org, index) => {
                      return (
                        <span key={index}>
                          <Link to={`/clients/${org.clientId}/organisations/${org.ID}/members`} className="meta">{org.name}</Link><br/>
                        </span>
                      )
                    })}
                  </td>
                  <td>
                    {member.unregisterDate ? moment.unix(member.unregisterDate).fromNow() : translate("Never")}
                  </td>
                  <td><input type="checkbox" onChange={(v) => { setChecked((prev) => v.target.checked ? [...prev, member.ID] : prev.filter(e => e !== member.ID)) }} checked={checked.includes(member.ID)} /></td>
                </tr>
              )
            })}
          </tbody>
        </table>

      </section>
    </div>
  );
}
